/**
 * Removes keys with `null` or empty-string values from a query-params object.
 * @param {Record<string, any>} queryParams
 * @returns {Record<string, any>}
 */
export const filteredQueryParams = (queryParams) =>
	Object.fromEntries(Object.entries(queryParams).filter(([_, value]) => value !== null && value !== ''))
